import { CancyPublicRereservationSubgraphUserErrorCode } from "@/public/gql/__generated__/graphql"

import type { GraphQLError } from "graphql"

const code_key = "code"

export const getExtensionsCode = (
	graphqlError: GraphQLError
): string | undefined => {
	const extensions = graphqlError.extensions

	if (extensions && typeof extensions[code_key] === "string") {
		const val: string = extensions[code_key]
		return val
	}

	return undefined
}

const slotUnavailableToCreateReservationErrorCodes: CancyPublicRereservationSubgraphUserErrorCode[] =
	["SLOT_UNAVAILABLE_TO_CREATE_RESERVATION"]

export const isSlotUnavailableToCreateReservationErrorCode = (
	code: string
): boolean => {
	return slotUnavailableToCreateReservationErrorCodes.includes(
		code as CancyPublicRereservationSubgraphUserErrorCode
	)
}

const isNoApolloAlertExtensionCode = (code: string): boolean => {
	return isSlotUnavailableToCreateReservationErrorCode(code)
}

export const getAppAlertMessagePublic = (
	graphqlError: GraphQLError
): string | undefined => {
	const code = getExtensionsCode(graphqlError)
	if (!code) {
		return undefined
	}

	if (isNoApolloAlertExtensionCode(code)) {
		return undefined
	}

	return graphqlError.message
}
